import {CHAT_ADMIN, CHATS} from '@constants/internal-route.constant'

// The feature urls the sidebar of the standard (Metronic) pages links to. The messenger itself has
// its own full-height layout (layouts/ChatLayout) with an icon rail; this sidebar serves the pages
// that use the standard ERP page types (notifications now; admin and compliance in later phases).
export const CHAT_ROUTES = [CHATS]

/** CHAT_ADMIN: the groups-and-channels list and the settings form share the one feature. */
export const ADMIN_ROUTES = [CHAT_ADMIN]

/** Every screen in the console, in sidebar order: the landing page's fallback list. */
export const ALL_ROUTES = [...CHAT_ROUTES, ...ADMIN_ROUTES]
